import { first, get, includes } from 'lodash/fp';
import { change } from 'redux-form';
import { CommanderThunkAction, OrderItem } from '@mews-commander/types';
import { lt, showSuccessAlert } from '@mews/framework';
import { rebateOrderItems as rebateOrderItemsAction } from '@mews-commander/legacy-entities/src/ducks/orderItems';
import { getRebateReasons } from '@mews-commander/legacy-entities/src/ducks/rebateReasons';
import { deselectAll, getSelectedOrderItemIds } from '../../ducks/billItems';
import { navigateToAccountBillingModal } from '../../ducks/navigation';
import { fieldNames } from '../constants';
import { RebateFormValues } from '../types';

interface CreateRebateProps {
    rebateReason: string;
    scope: string;
}

interface RebateOrderItemsActionResult {
    value: {
        rebateOrderItems: Array<OrderItem>;
    };
}

export const createRebate =
    ({ rebateReason, scope }: CreateRebateProps): CommanderThunkAction =>
    (dispatch, getState) => {
        const selectedServiceOrders = getSelectedOrderItemIds(getState(), { scope });

        return (
            dispatch(rebateOrderItemsAction({ ids: selectedServiceOrders, reason: rebateReason })) as $TSFixMe
        ).then(({ value: { rebateOrderItems } }: RebateOrderItemsActionResult) => {
            const firstOrderItem = first(rebateOrderItems);
            const billId = get('billId', firstOrderItem);
            const ownerId = get('ownerId', firstOrderItem);
            showSuccessAlert({ description: lt('RebateFormSuccess') });
            dispatch(navigateToAccountBillingModal({ accountId: ownerId, billId }));
            dispatch(deselectAll(scope));
        });
    };

export const changeRebateFormValues =
    (values: RebateFormValues, form: string, prevValues: RebateFormValues): CommanderThunkAction =>
    (dispatch, getState) => {
        const rebateReasons = getRebateReasons(getState());
        const reason = values[fieldNames.REBATE_REASON];
        const preselectedReason = values[fieldNames.PRESELECTED_REBATE_REASON];

        const reasonChanged = reason !== prevValues[fieldNames.REBATE_REASON];
        const preselectedReasonChanged = preselectedReason !== prevValues[fieldNames.PRESELECTED_REBATE_REASON];

        const isExistingReason = includes(reason, rebateReasons);

        if (reasonChanged) dispatch(change(form, fieldNames.PRESELECTED_REBATE_REASON, isExistingReason ? reason : ''));

        if (preselectedReasonChanged && preselectedReason?.length) {
            dispatch(change(form, fieldNames.REBATE_REASON, preselectedReason));
        }
    };
